"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  AlignMiddleMoveVertical: ['align-middle-move-vertical', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23,11H19.75a.25.25,0,0,1-.25-.25V6.5a1,1,0,0,0-1-1h-4a1,1,0,0,0-1,1v4.25a.25.25,0,0,1-.25.25h-2.5a.25.25,0,0,1-.25-.25V3.5a1,1,0,0,0-1-1h-4a1,1,0,0,0-1,1v7.25a.25.25,0,0,1-.25.25H1a1,1,0,0,0,0,2H4.25a.25.25,0,0,1,.25.25V20.5a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V13.25a.25.25,0,0,1,.25-.25h2.5a.25.25,0,0,1,.25.25V17.5a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V13.25a.25.25,0,0,1,.25-.25H23a1,1,0,0,0,0-2Z']],
  AlignRight: ['align-right', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.25,1a1,1,0,0,0-1,1V22a1,1,0,0,0,2,0V2A1,1,0,0,0,21.25,1Z', 'M7.750 5.000 L18.750 5.000 L18.750 11.000 L7.750 11.000 Z', 'M1.750 13.000 L18.750 13.000 L18.750 19.000 L1.750 19.000 Z']],
  AlignLeftMove: ['align-left-move', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1,0A1,1,0,0,0,0,1V23a1,1,0,0,0,2,0V1A1,1,0,0,0,1,0Z', 'M5.000 4.500 L24.000 4.500 L24.000 10.500 L5.000 10.500 Z', 'M5.000 13.500 L18.000 13.500 L18.000 19.500 L5.000 19.500 Z']],
  AlignLeftRight: ['align-left-right', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,4.5h-.5V1a1,1,0,0,0-2,0V4.5H19a1,1,0,0,0-1,1v13a1,1,0,0,0,1,1h.5V23a1,1,0,0,0,2,0V19.5H22a1,1,0,0,0,1-1V5.5A1,1,0,0,0,22,4.5Z', 'M5,6.5H4.5V3a1,1,0,0,0-2,0V6.5H2a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1h.5V21a1,1,0,0,0,2,0V17.5H5a1,1,0,0,0,1-1v-9A1,1,0,0,0,5,6.5Z', 'M14.207,9.293a1,1,0,0,0-1.414,1.414L14.086,12l-1.293,1.293a1,1,0,0,0,1.414,1.414l2-2a1,1,0,0,0,0-1.414Z', 'M11.207,9.293a1,1,0,0,0-1.414,0l-2,2a1,1,0,0,0,0,1.414l2,2a1,1,0,0,0,1.414-1.414L9.914,12l1.293-1.293A1,1,0,0,0,11.207,9.293Z']],
  AlignRightMove: ['align-right-move', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23,0a1,1,0,0,0-1,1V23a1,1,0,0,0,2,0V1A1,1,0,0,0,23,0Z', 'M0.000 4.500 L19.000 4.500 L19.000 10.500 L0.000 10.500 Z', 'M6.000 13.500 L19.000 13.500 L19.000 19.500 L6.000 19.500 Z']],
  AlignTopBottom: ['align-top-bottom', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.5,18H5.5a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h13a1,1,0,0,0,1-1V19A1,1,0,0,0,18.5,18Zm-3.75,2.5a.75.75,0,0,1-.75.75H10a.75.75,0,0,1,0-1.5h4A.75.75,0,0,1,14.75,20.5Z', 'M7.5,6h9a1,1,0,0,0,1-1V2a1,1,0,0,0-1-1h-9a1,1,0,0,0-1,1V5A1,1,0,0,0,7.5,6ZM9.25,3.5A.75.75,0,0,1,10,2.75h4a.75.75,0,0,1,0,1.5H10A.75.75,0,0,1,9.25,3.5Z', 'M13.293,12.793,12,14.086l-1.293-1.293a1.025,1.025,0,0,0-1.414,0,1,1,0,0,0,0,1.414l2,2a1,1,0,0,0,1.414,0l2-2a1,1,0,0,0,0-1.414A1.025,1.025,0,0,0,13.293,12.793Z', 'M10.707,11.207,12,9.914l1.293,1.293a1,1,0,0,0,1.414-1.414l-2-2a1.025,1.025,0,0,0-1.414,0l-2,2a1,1,0,0,0,0,1.414A1.025,1.025,0,0,0,10.707,11.207Z']],
  AlignTopMove: ['align-top-move', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23,0H1A1,1,0,0,0,1,2H23a1,1,0,0,0,0-2Z', 'M4.500 5.000 L10.500 5.000 L10.500 24.000 L4.500 24.000 Z', 'M13.500 5.000 L19.500 5.000 L19.500 18.000 L13.500 18.000 Z']],
  AlignLeft: ['align-left', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.75,1a1,1,0,0,0-1,1V22a1,1,0,0,0,2,0V2A1,1,0,0,0,2.75,1Z', 'M5.250 5.000 L16.250 5.000 L16.250 11.000 L5.250 11.000 Z', 'M5.250 13.000 L22.250 13.000 L22.250 19.000 L5.250 19.000 Z']],
  AlignMiddleMoveHorizontal: ['align-middle-move-horizontal', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.5,13.5H13.25a.25.25,0,0,1-.25-.25v-2.5a.25.25,0,0,1,.25-.25H17.5a1,1,0,0,0,1-1v-4a1,1,0,0,0-1-1H13.25A.25.25,0,0,1,13,4.25V1a1,1,0,0,0-2,0V4.25a.25.25,0,0,1-.25.25H6.5a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h4.25a.25.25,0,0,1,.25.25v2.5a.25.25,0,0,1-.25.25H3.5a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h7.25a.25.25,0,0,1,.25.25V23a1,1,0,0,0,2,0V19.75a.25.25,0,0,1,.25-.25H20.5a1,1,0,0,0,1-1v-4A1,1,0,0,0,20.5,13.5Z']],
  AlignBottomMove: ['align-bottom-move', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23,22H1a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z', 'M13.500 0.000 L19.500 0.000 L19.500 19.000 L13.500 19.000 Z', 'M4.500 6.000 L10.500 6.000 L10.500 19.000 L4.500 19.000 Z']],
  AlignCenter: ['align-center', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19,12.5H13.25a.25.25,0,0,1-.25-.25v-1a.25.25,0,0,1,.25-.25H16a1.5,1.5,0,0,0,1.5-1.5v-3A1.5,1.5,0,0,0,16,5H13.25A.25.25,0,0,1,13,4.75V2a1,1,0,0,0-2,0V4.75a.25.25,0,0,1-.25.25H8A1.5,1.5,0,0,0,6.5,6.5v3A1.5,1.5,0,0,0,8,11h2.75a.25.25,0,0,1,.25.25v1a.25.25,0,0,1-.25.25H5A1.5,1.5,0,0,0,3.5,14v3A1.5,1.5,0,0,0,5,18.5h5.75a.25.25,0,0,1,.25.25V22a1,1,0,0,0,2,0V18.75a.25.25,0,0,1,.25-.25H19A1.5,1.5,0,0,0,20.5,17V14A1.5,1.5,0,0,0,19,12.5Z']],
  AlignTop: ['align-top', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,1.75H2a1,1,0,0,0,0,2H22a1,1,0,0,0,0-2Z', 'M13.000 5.250 L19.000 5.250 L19.000 16.250 L13.000 16.250 Z', 'M5.000 5.250 L11.000 5.250 L11.000 22.250 L5.000 22.250 Z']],
  AlignMiddle: ['align-middle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23,12a1,1,0,0,0-1-1H19.25a.25.25,0,0,1-.25-.25V8a1.5,1.5,0,0,0-1.5-1.5h-3A1.5,1.5,0,0,0,13,8v2.75a.25.25,0,0,1-.25.25h-1a.25.25,0,0,1-.25-.25V5A1.5,1.5,0,0,0,10,3.5H7A1.5,1.5,0,0,0,5.5,5v5.75a.25.25,0,0,1-.25.25H2a1,1,0,0,0,0,2H5.25a.25.25,0,0,1,.25.25V19A1.5,1.5,0,0,0,7,20.5h3A1.5,1.5,0,0,0,11.5,19V13.25a.25.25,0,0,1,.25-.25h1a.25.25,0,0,1,.25.25V16a1.5,1.5,0,0,0,1.5,1.5h3A1.5,1.5,0,0,0,19,16V13.25a.25.25,0,0,1,.25-.25H22A1,1,0,0,0,23,12Z']],
  AlignBottom: ['align-bottom', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,20.25H2a1,1,0,0,0,0,2H22a1,1,0,0,0,0-2Z', 'M13.000 7.750 L19.000 7.750 L19.000 18.750 L13.000 18.750 Z', 'M5.000 1.750 L11.000 1.750 L11.000 18.750 L5.000 18.750 Z']]
};
exports["default"] = _default;